import { action } from 'typesafe-actions';

import { IAudienceMinuteState, IEPGProgramState } from '../Timeline/Types';
import {
    ISetBackgroundPopoverAction,
    ISetBroadcasterPopoverAction,
    ISetCurrentMinuteAction,
    ISetDeclarativePopoverAction,
    ISetDeclarativeRadioPopoverAction,
    ISetMusicPopoverAction,
    ISetReadjustedPopoverAction,
    ISetTalkPopoverAction,
    ISetXMLPopoverAction,
    TimelinePopoversActionTypes,
} from './Types';

export const setBackgroundPopover = (prg: IEPGProgramState | null): ISetBackgroundPopoverAction =>
    action(TimelinePopoversActionTypes.SET_BACKGROUND_POPOVER, prg);
export const setBroadcasterPopover = (prg: IEPGProgramState | null): ISetBroadcasterPopoverAction =>
    action(TimelinePopoversActionTypes.SET_BROADCASTER_POPOVER, prg);
export const setCurrentMinute = (minute: IAudienceMinuteState): ISetCurrentMinuteAction =>
    action(TimelinePopoversActionTypes.SET_CURRENT_MINUTE, minute);
export const setDeclarativePopover = (prg: IEPGProgramState | null): ISetDeclarativePopoverAction =>
    action(TimelinePopoversActionTypes.SET_DECLARATIVE_POPOVER, prg);
export const setDeclarativeRadioPopover = (prg: IEPGProgramState | null): ISetDeclarativeRadioPopoverAction =>
    action(TimelinePopoversActionTypes.SET_DECLARATIVERADIO_POPOVER, prg);
export const setMusicPopover = (prg: IEPGProgramState | null): ISetMusicPopoverAction =>
    action(TimelinePopoversActionTypes.SET_MUSIC_POPOVER, prg);
export const setReadjustedPopover = (prg: IEPGProgramState | null): ISetReadjustedPopoverAction =>
    action(TimelinePopoversActionTypes.SET_READJUSTED_POPOVER, prg);
export const setTalkPopover = (prg: IEPGProgramState | null): ISetTalkPopoverAction =>
    action(TimelinePopoversActionTypes.SET_TALK_POPOVER, prg);
export const setXMLPopover = (prg: IEPGProgramState | null): ISetXMLPopoverAction =>
    action(TimelinePopoversActionTypes.SET_XML_POPOVER, prg);
